import { request, requestConfig } from 'utils/request.js';

import {
    FETCH_ASSIGNMENTS_FOR_PINPOINT, FETCH_ASSIGNMENTS_FOR_PINPOINT_SUCCESS, FETCH_ASSIGNMENTS_FOR_PINPOINT_FAILURE,
    FETCH_PINPOINTS, FETCH_PINPOINTS_SUCCESS, FETCH_PINPOINTS_FAILURE,
    REMOVE_PINPOINT, REMOVE_PINPOINT_SUCCESS, REMOVE_PINPOINT_FAILURE,
    CLEAR_PINPOINT, EMPTY_PINPOINTS, SET_PINPOINT, UPDATE_PINPOINTS, UPDATE_SEARCH_TERM
} from './constants';

import { PATHS } from 'utils/paths';

const fetchAssignmentsForPinpoint = () => ({
    type: FETCH_ASSIGNMENTS_FOR_PINPOINT
});

const fetchAssignmentsForPinpointSuccess = () => ({
    type: FETCH_ASSIGNMENTS_FOR_PINPOINT_SUCCESS
});

const fetchAssignmentsForPinpointFailure = (error) => ({
    type: FETCH_ASSIGNMENTS_FOR_PINPOINT_FAILURE,
    error
});

const fetchPinpoints = () => ({
    type: FETCH_PINPOINTS
});

const fetchPinpointsSuccess = (data) => ({
    type: FETCH_PINPOINTS_SUCCESS,
    data
});

const fetchPinpointsFailure = (error) => ({
    type: FETCH_PINPOINTS_FAILURE,
    error
});

const removePinpoint = () => ({
    type: REMOVE_PINPOINT
});

const removePinpointSuccess = () => ({
    type: REMOVE_PINPOINT_SUCCESS
});

const removePinpointFailure = (error) => ({
    type: REMOVE_PINPOINT_FAILURE,
    error
});

export const clearPinpoint = () => ({
    type: CLEAR_PINPOINT
});

export const emptyPinpoints = () => ({
    type: EMPTY_PINPOINTS
});

export const setPinpoint = (data) => ({
    type: SET_PINPOINT,
    data
});

export const updatePinpoints = (data) => ({
    type: UPDATE_PINPOINTS,
    data
});

export const updateSearchTerm = (data) => ({
    type: UPDATE_SEARCH_TERM,
    data
});


/**
 *  ASYNC ACTIONS
 */

export const deletePinpoint = (callback) => (dispatch, getState) => {
    dispatch(removePinpoint());
    let pinpoint = getState().pinpoints.pinpoint;
    request(PATHS.content.putPinpoint(pinpoint.id), requestConfig('DELETE'))
        .then(() => {
            // Loop through all existing content to see if this user exists. If so, remove it
            let allPinpoint = getState().content.all;
            for(var i = 0, l = allPinpoint.length; i < l; i++) {
                if(allPinpoint[i].id === pinpoint.id) {
                    allPinpoint.splice(i, 1);
                    break;
                }

            }
            dispatch(removePinpointSuccess());
            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            dispatch(removePinpointFailure(error));
        })
};

export const getAssignmentsAndSetPinpoint = (pinpoint) => (dispatch) => {
    dispatch(setPinpoint(pinpoint));
    dispatch(fetchAssignmentsForPinpoint());

    let completedCount = 0;
    let assignments = [];
    pinpoint.assignmentIds.forEach((id) => {
        request(PATHS.assignments.getAssignment(id), requestConfig('GET'))
            .then((assignment) => {
                completedCount++;
                assignments.push(assignment);
                if(completedCount === pinpoint.assignmentIds.length) {
                    pinpoint.assignments = assignments;
                    dispatch(fetchAssignmentsForPinpointSuccess());
                    dispatch(setPinpoint(pinpoint));
                }
            })
            .catch((error) => {
                console.log('error getting assignment', error);
                dispatch(fetchAssignmentsForPinpointFailure(error));
            });
    });
};

export const getPinpoints = (callback) => (dispatch, getState) => {
    dispatch(fetchPinpoints());

    let pinpointsState = getState().pinpoints;
    let path = '';
    let pageNumber = pinpointsState.pageNumber + 1;

    if(pinpointsState.searchTerm !== '') {
        path = PATHS.pinpoints.getPinpoints.search(pinpointsState.searchTerm, pageNumber, pinpointsState.pageSize);
    } else if(pinpointsState.filterBy !== '') {
        let userId = getState().auth.user.id;
        path = PATHS.pinpoints.getPinpoints.filtered(pinpointsState.filterBy, pinpointsState.sortBy, pinpointsState.sortDirection, pageNumber, pinpointsState.pageSize, userId);
    } else {
        path = PATHS.pinpoints.getPinpoints.sorted(pinpointsState.sortBy, pinpointsState.sortDirection, pageNumber, pinpointsState.pageSize);
    }

    request(path, requestConfig('GET'))
        .then((data) => {
            dispatch(fetchPinpointsSuccess(data));
            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            console.log(error);
            dispatch(fetchPinpointsFailure(error));
        });
};



// WEBPACK FOOTER //
// ./src/containers/PinpointsPage/store/actions.js